import { Controller } from "stimulus"
import Utility from '../classes/Utility';

class Carousel extends Controller {

  static targets = [
    'carouselSlider',
    'contentInnerSlider',
    'carouselItemContainer',
    'carouselItem',
  ]

  connect() {
    this.init();
    window.addEventListener("resize", Utility.debounce(this.init.bind(this), 200));

    EventManager.on('update-carousel-page', ({ width, idx, setHeight }) => {
      this.moveSliderToIndex(width, idx, setHeight);
    })
  }

  init() {
    const singlePageWidth = window.getComputedStyle(this.carouselSliderTarget).width;
    this.carouselItemTargets.forEach(carouselItem => {
      carouselItem.style.width = singlePageWidth;
      carouselItem.classList.remove('t-w-screen');
    });
    const carouselItemContainerComputedStyle = window.getComputedStyle(this.carouselItemContainerTarget);
    const carouselItemContainerMarginX = parseFloat(carouselItemContainerComputedStyle.marginRight) + parseFloat(carouselItemContainerComputedStyle.marginLeft);
    const itemWidth = this.carouselItemContainerTarget.offsetWidth + carouselItemContainerMarginX;
    EventManager.emit('update-carousel-pagination-state', {
      width: itemWidth
    });
    this.moveSliderToIndex(itemWidth, 0, false);
  }

  moveSliderToIndex(itemWidth, idx, setHeight = true) {
    this.contentInnerSliderTarget.style.transform = `translateX(-${itemWidth * idx}px)`;
    if (setHeight) {
      this.contentInnerSliderTarget.style.height = `${this.carouselItemTargets[idx].offsetHeight}px`;
      this.contentInnerSliderTarget.style.marginBottom = '24px';
    }
  }
}

export default Carousel;

